import camelize from 'camelcase-keys-deep';

export default class UserSpecie {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  specie() {
    return this.specieId ? this.env().Specie.findBy('id', this.specieId) : null;
  }
}
